import { render } from "./GamesView.vue?vue&type=template&id=8064b9fc&scoped=true"
import script from "./GamesView.vue?vue&type=script&lang=js"
export * from "./GamesView.vue?vue&type=script&lang=js"

import "./GamesView.vue?vue&type=style&index=0&id=8064b9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8064b9fc"]])

export default __exports__